import type * as React from "react";
import {
  Tooltip,
  tooltipClasses,
  styled,
  TooltipProps,
  Box
} from "@mui/material";
import { COLORS } from "../../Theme/colors";

const GLTooltipStyled = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLORS.BLACK,
    color: COLORS.WHITE,
    maxWidth: 250,
    fontSize: theme.typography.pxToRem(14),
    padding: "10px 15px",
    borderRadius: "8px"
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLORS.BLACK
  },
  // Keep the rotated-square arrow overlapping the bubble so a hairline
  // gap does not appear at the join, especially near rounded corners.
  [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
    marginRight: "-0.62em"
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
    marginLeft: "-0.62em"
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
    marginBottom: "-0.62em"
  },
  [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
    marginTop: "-0.62em"
  }
}));

const GLTooltip: React.FC<TooltipProps> = ({
  children,
  placement = "right",
  title,
  PopperProps,
  ...rest
}) => {
  return (
    <GLTooltipStyled
      title={title}
      placement={placement}
      arrow
      PopperProps={{
        ...PopperProps,
        modifiers: [
          {
            name: "arrow",
            options: {
              padding: 8
            }
          },
          ...(PopperProps?.modifiers ?? [])
        ]
      }}
      {...rest}
    >
      <Box component="span">{children}</Box>
    </GLTooltipStyled>
  );
};

export default GLTooltip;
